// 订单管理
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

export class OrderGoodsApi {

    constructor() {
    }
    protected static groupUrl = '/ordering/man/order/items';

    //订货单手动下单
    public static async delete(data) {
        //let uri = this.groupUrl + '/delete';
        //return await ServerDistApi.send(uri, data);
    }

    //新增商品查询所有商品
    public static async getAllGoodsList(data) {
        let uri = this.groupUrl + '/addTo';
        return await ServerDistApi.send(uri, data);
    }
    //支付方式列表
    public static async PaysList(data) {
        let uri = '/common/client/config/paysource';
        return await ServerDistApi.get(uri, data);
    }

    //删除商品
    public static async deleteGoods(data) {
        let uri = this.groupUrl + '/del';
        return await ServerDistApi.send(uri, data);
    }

    //新增商品
    public static async addGoods(data) {
        let uri = this.groupUrl + '/add';
        return await ServerDistApi.send(uri, data);
    }

    //发货单换货
    public static async ReplaceGoods(data) {
        let uri = this.groupUrl + '/change';
        return await ServerDistApi.send(uri, data);
    }
}

